import { createSlice } from '@reduxjs/toolkit';
import { flatMap, uniq } from 'lodash';
import moment from 'moment/moment';
import { fetchAllRules } from './RulesThunks';

const initialState = {
  data: [],
  isFetching: false,
  error: null,
  credits: {
    obligationYears: [],
  },
};

export const RulesSlice = createSlice({
  name: 'rules',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllRules.pending, (state) => {
        state.isFetching = true;
        state.error = null;
      })
      .addCase(fetchAllRules.fulfilled, (state, action) => {
        state.isFetching = false;
        state.error = null;
        state.data = action.payload;
        state.credits.obligationYears = uniq(
          flatMap(
            action.payload.filter((rule) => rule.keyValue1 === 'CREDITS'),
            'formulas'
          ).map((f) => f.yearRange)
        )
          .map((f) => {
            const [start, end] = f.split('-');
            return {
              label: f,
              value: {
                fromDate: moment.utc(`${start}-03-31`).hour(18).minute(30).second(0).toISOString(),
                toDate: moment.utc(`${end}-03-31`).hour(18).minute(29).second(59).toISOString(),
              },
            };
          })
          .sort((a, b) => a.label.localeCompare(b.label));
      })
      .addCase(fetchAllRules.rejected, (state) => {
        state.isFetching = false;
        state.error = 500;
      });
  },
});

export default RulesSlice.reducer;
